import { nanoid } from 'nanoid';

import sqlProjects from './projects/sqlData';
import advancedJavaProjects from './projects/advancedJavaData';
import basicJavaProjects from './projects/basicJavaData';
import advancedJSProjects from './projects/advancedJSData';
import basicJSProjects from './projects/basicJSData';

const sqlProjectCount = sqlProjects.length;
const advancedJavaProjectCount = advancedJavaProjects.length;
const basicJavaProjectCount = basicJavaProjects.length;
const advancedJSProjectCount = advancedJSProjects.length;
const basicJSProjectCount = basicJSProjects.length;

// MAIN PAGE PROJECTS DATA
const projectsData = [
  // {
  //   id: nanoid(),
  //   img: '',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: '',
  // },

  {
    id: nanoid(),
    img: 'showcase_sql.png',
    title: 'SQL:',
    subtitle: 'Query away.',
    projectCount: `${sqlProjectCount} projects`,
    info: 'This project series focuses on SQL query optimization, aiming to enhance database efficiency and performance.',
    info2: 'Explore my journey to become SQL proficient.',
    url: '/showcase/sql',
    repo: '',
  },

  {
    id: nanoid(),
    img: 'showcase_basicJava.png',
    title: 'Java OOP:',
    subtitle: 'Fun with Complexity',
    projectCount: `${basicJavaProjectCount} projects`,
    info: "This collection explores Java's advanced features and OOP principles, emphasizing efficient software development.",
    info2:
      "My projects highlight strategic use of Java's robust features, prioritizing well-architected, maintainable code and sophisticated design patterns.",
    url: '/showcase/basicJava',
    repo: '',
  },

  {
    id: nanoid(),
    img: 'showcase_advancedJS.png',
    title: 'Ensure a solid foundation:',
    subtitle: 'Add some React(ions)',
    projectCount: `${advancedJSProjectCount} project`,
    info: "In this collection, I explore the synergy between React's dynamic features and core web development principles.",
    info2:
      'These projects showcase a leap in my skills, evolving into intuitive, responsive, and user-focused web applications.',
    url: '/showcase/advancedJS',
    repo: '',
  },

  {
    id: nanoid(),
    img: 'showcase_basicJS.png',
    title: 'Cover your bases:',
    subtitle: 'HTML, CSS, JavaScript',
    projectCount: `${basicJSProjectCount} projects`,
    info: "A series of small, yet impactful projects where I've applied HTML, CSS and JavaScript to create functional and aesthetically pleasing web designs. ",
    info2: 'Each project highlights my technical skills in structuring and styling web pages.',
    url: '/showcase/basicJS',
    repo: '',
  },
];

export default projectsData;
